module.exports = __webpack_public_path__ + "static/media/123.b5b850fe.jpg";